import { isRtl } from '@helpers/locale';

import { IsRtlActionTypes } from './types';

export const changeIsRtl = (locale: string): { type: IsRtlActionTypes; payload: boolean } => ({
  type: IsRtlActionTypes.ChangeIsRtl,
  payload: isRtl(locale),
});
